class statisticsSalesRankDetailCtrl {
    constructor($scope, httpRequest, $state) {
        // 存储页面信息
        $scope.pageState = {
            idToken: localStorage.id_token,
            userInfo: JSON.parse(localStorage.user_info),
        }
        // 字典数据
        $scope.dictData = {}
        $scope.dictData.cancel_status = [
            { enumTypeCode: null, enumName: '正常', enumCode: '0' },
            { enumTypeCode: null, enumName: '已作废', enumCode: '1' },
        ]
        const typecodeArr = ['inv_type', 'invoice_status', 'is_red']
        httpRequest.get_dictByTypeArr(typecodeArr).then((res) => {
            $scope.dictData = $.extend($scope.dictData, res.data.value)
        })

        const invObj = JSON.parse($state.params.params)
        $scope.param = {
            pageNum: 1,
            pageSize: 10,
            param: {
                custCreditCode: invObj.custCreditCode,
                custName: invObj.custName,
                invoiceDateBegin: invObj.invoiceDateBegin,
                invoiceDateEnd: invObj.invoiceDateEnd,
                invoiceType: invObj.invoiceType,
                saleName: invObj.saleName,
                saleCreditCode: invObj.saleCreditCode,
                accessToken: $scope.pageState.idToken,
            },
        }

        // 导出
        $scope.exportInvoic = function () {
            httpRequest.get_exportInvoiceRateToXLS($scope.param.param)
        }

        // 分页
        $scope.totalItems = 0 // 组件初始化设置总页数
        // $scope.currentPage = 1 // 设置显示第一页
        // $scope.maxSize = 10 // 每一叶显示记录数
        queryInfo()

        $scope.pageChanged = function () { // 点击页码发起查询
            queryInfo()
        }

        function queryInfo() {
            httpRequest.post_selectSaleInfoDetail($scope.param).then((res) => {
                $scope.listData = res.data.value.list

                // 获取后台分页数据 回写分页组件
                $scope.totalItems = res.data.value.total //
                // $scope.currentPage = ++res.data.value.prePage
                // $scope.maxSize = res.data.value.pageSize
            })
        }
    }
}
statisticsSalesRankDetailCtrl.$inject = ['$scope', 'httpRequest', '$state']
export default statisticsSalesRankDetailCtrl



// WEBPACK FOOTER //
// ./src/app/statistics/outputStatistics/statisticsSalesRank/statisticsSalesRankDetailCtrl.js